<template>
  <div class="site-form-element-wrapper" :id="uniqId">
    <div class="site-form-element">
      <input
          ref="phoneInput"
          :class="{'site-form-input input':true, 'has-error':!!errorMessage}"
          type="text"
          :name="inputName"
          :value="modelValue"
          placeholder=""
          @change="onChange"
          @keydown="handleTyping"
          @focus="handleTyping"
      >
      <label class="site-form-label">{{ label }}</label>

      <div class="site-form-icons">
        <img class="site-form-icons-item cancel" src="/assets/images/icons/form/cancel.svg" @click.prevent="clear">
        <img class="site-form-icons-item error" src="/assets/images/icons/form/error.svg">
      </div>
    </div>

    <div class="site-form-error" v-if="errorMessage">{{ errorMessage }}</div>
  </div>
</template>

<script>

import Inputmask from "maskedinput";

export default {
  name: "phone",
  props: {
    name: {
      type: String,
      default: null
    },
    customName: {
      type: String,
      default: null
    },
    label: {
      type: String
    },
    modelValue: {
      type: String,
      default: null
    },
  },
  inject: ['errors', 'formKey'],
  computed: {
    inputName: function () {
      return this.customName ? `${this.formKey}${this.customName}` : `${this.formKey}[${this.name}]`;
    },
    uniqId: function () {
      return `field-${this.name ?? this.customName}`;
    },
    errorMessage: function () {
      const errors = this.errors[this.name];
      return errors ? errors.join('') : null;
    }
  },
  mounted() {
    let im = new Inputmask("+7 (999) 999 99 99", {placeholder: "+7 (___) ___ __ __"});
    im.mask(this.$refs.phoneInput);
  },
  methods: {
    handleTyping() {
      this.errors[this.name] = null;
    },
    clear() {
      this.$emit('update:modelValue', null);
    },
    onChange(event) {
      this.$emit('update:modelValue', event.target.value);
    },
  },
}
</script>

<style scoped>

</style>